<div class="top"></div>
<img [src]="'assets/icon/success/' + content().type + '.svg'" />
<div>
    <div>
        <web-device-type-label title [type]="content().type" [surname]="content().surname" />

        @if (content().serial) {
            <div class="sub-headline-bold grey">{{ content().serial }}</div>
        }
        @if (content().text) {
            <div class="body-medium yellow">{{ content().text }}</div>
        }
    </div>
</div>
<web-bottom-buttons [buttons]="content().buttons ?? []"></web-bottom-buttons>
